import { IComponentOptions, IController } from "angular";
import dayjs from "@gtmhub/dayjs";
import { Metric } from "@webapp/okrs/metrics/models/metric.models";
import { Session } from "@webapp/sessions/models/sessions.model";

class MetricBarProgressComponentCtrl implements IController {
  metric: Metric;
  planningSession: Session;
  formattedSoftDueDate: string;

  $onInit(): void {
    this.formattedSoftDueDate = dayjs(this.metric.softDueDate).format("DD MMMM, YYYY");
  }
}

export const MetricBarProgressComponent: IComponentOptions = {
  template: require("./metric-bar-progress.html"),
  controller: MetricBarProgressComponentCtrl,
  bindings: {
    metric: "<",
    planningSession: "<",
  },
};
